import React from "react";

import ActivityIcon from "@uui/Activity";

import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";

const NotEnoughData = () => {
  return (
    <EmptyStateContainer flex={1}>
      <EmptyStateIcon Icon={ActivityIcon} padding={2} />
      <EmptyStateTitle>Not enough data</EmptyStateTitle>
      <EmptyStateSubtext>
        Add Read to your upcoming meetings to start generating topic
        progression, action items, and key questions for all members in your
        Workspace.
      </EmptyStateSubtext>
    </EmptyStateContainer>
  );
};

export default NotEnoughData;
